import React from 'react';
import Head from 'next/head';

const LiberiumHead = ({ children, ...props }) => {
    return (
        <Head {...props}>
            {children}
        </Head>
    );
}

export default LiberiumHead;